import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LayoutLanding from './pages/LayoutLanding';
import UserRegistration from './pages/UserRegistration';
import LayoutAdminHeader from './components/LayoutAdminHeader';
import LayoutUserHeader from './components/LayoutUserHeader';
import LayoutUserFooter from './components/LayoutUserFooter';
import UserDashboard from './pages/UserDashboard';
import AdminDashboard from './pages/AdminDashboard';
import GetAllRegistrations from './pages/GetAllRegistrations';
import LayoutLandingHeader from './components/LayoutLandingHeader'
import Carousel from './components/Carousel'
import ServicesCard from './components/ServicesCard'
import Login from './pages/Login';
import AboutUS from './components/AboutUS';
import ContactUS from './components/ContactUS';
import AddSaleInvoice from './pages/AddSaleInvoice';
import AddPurchaseInvoice from './pages/AddPurchaseInvoice';
import ProductList from './pages/ProductList';
import HsnSac from './pages/HsnSac';
import Unit from './pages/Unit';
import ProductUnitHsnMapping from './pages/ProductUnitHsnMapping';
import ThankYou from './pages/ThankYou';
import ServiceList from './pages/ServiceList';
import GSTPercentageList from './pages/GSTPercentageList';
import GetSaleInvoices from './pages/GetSaleInvoices';
import GetPurchaseInvoice from './pages/GetPurchaseInvoice';
import ContactUs from './pages/ContactUs';
import PrivacyPolicy from './pages/PrivacyPolicy';
import RefundPolicy from './pages/RefundPolicy';
import TermsandConditions from './pages/TermsandConditions';
import OrderList from './pages/OrderList';
import SaleInvoiceHeader from './pages/SaleInvoiceHeader';
import SaleInvoiceConsigneeDetails from './pages/SaleInvoiceConsigneeDetails';
import SaleInvoiceItems from './pages/SaleInvoiceItems';
import SaleInvoiceBankCashDetails from './pages/SaleInvoiceBankCashDetails';
import SaleInvoiceTermsAndSubmit from './pages/SaleInvoiceTermsAndSubmit';
import EditSaleInvoice from './pages/EditSaleInvoice';
import GetAllSaleInvoices from './pages/GetAllSaleInvoices';
import GetAllPurchaseInvoices from './pages/GetAllPurchaseInvoices';
import ExcelUploader from './pages/ExcelUploader';
import PurchaseInvoiceExcelUploader from './pages/PurchaseInvoiceExcelUploader';
import PurchaseExcelUploader from './pages/PurchaseExcelUploader';
import Discount from './pages/Discount';
import ForgetPassword from './pages/ForgetPassword';
import AdminReport from './pages/AdminReport';
import ChangePassword from './pages/ChangePassword';
import PaymentDetails from './pages/PaymentDetails';
import AddPayment from './pages/AddPayment';
import './App.css';
import React, { useEffect } from 'react';


function App() {
// ✅ Clear cookies on app load
  useEffect(() => {
    document.cookie.split(";").forEach((cookie) => {
      document.cookie = cookie
        .replace(/^ +/, "")
        .replace(/=.*/, `=;expires=${new Date(0).toUTCString()};path=/`);
    });
  }, []);
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LayoutLanding />} />
        <Route path="UserRegistration" element={<UserRegistration />} />
        <Route path="/GetAllRegistrations" element={<GetAllRegistrations />} />
        <Route path="LayoutAdminHeader" element={<LayoutAdminHeader />} />
        <Route path="LayoutUserHeader" element={<LayoutUserHeader />} />
        <Route path="LayoutUserFooter" element={<LayoutUserFooter />} />
        <Route path="UserDashboard" element={<UserDashboard />} />
        <Route path="AdminDashboard" element={<AdminDashboard />} />
        <Route path="/UserRegistration/:id" element={<UserRegistration />} />
        <Route path="/Login" element={<Login />} />
        <Route path="/AboutUS" element={<AboutUS />} />
        <Route path="/ContactUS" element={<ContactUS />} />
        <Route path="ThankYou" element={<ThankYou />} />
        <Route path="AddSaleInvoice" element={<AddSaleInvoice />} /> 
        <Route path="GetSaleInvoices" element={<GetSaleInvoices />} /> 
        <Route path="AddPurchaseInvoice" element={<AddPurchaseInvoice />} /> 
        <Route path="GetPurchaseInvoice" element={<GetPurchaseInvoice />} />
        <Route path="/AddPurchaseInvoice/:id?" element={<AddPurchaseInvoice />} /> 
        <Route path="ProductList" element={<ProductList />} /> 
        <Route path="HsnSac" element={<HsnSac />} /> 
        <Route path="Unit" element={<Unit />} /> 
        <Route path="ProductUnitHsnMapping" element={<ProductUnitHsnMapping />} /> 
        <Route path="LayoutLandingHeader" element={<LayoutLandingHeader />} /> 
        <Route path="Carousel" element={<Carousel />} /> 
        <Route path="ServicesCard" element={<ServicesCard />} /> 
        <Route path="ServiceList" element={<ServiceList />} /> 
        <Route path="GSTPercentageList" element={<GSTPercentageList />} /> 
        <Route path="AddSaleInvoice" element={<AddSaleInvoice />} /> 
        <Route path="ContactUs" element={<ContactUs />} /> 
        <Route path="PrivacyPolicy" element={<PrivacyPolicy />} /> 
        <Route path="TermsandConditions" element={<TermsandConditions />} /> 
        <Route path="RefundPolicy" element={<RefundPolicy />} /> 
        <Route path="OrderList" element={<OrderList />} /> 
        <Route path="SaleInvoiceHeader" element={<SaleInvoiceHeader />} /> 
        <Route path="SaleInvoiceConsigneeDetails" element={<SaleInvoiceConsigneeDetails />} /> 
        <Route path="SaleInvoiceItems" element={<SaleInvoiceItems />} /> 
        <Route path="SaleInvoiceBankCashDetails" element={<SaleInvoiceBankCashDetails />} /> 
        <Route path="SaleInvoiceTermsAndSubmit" element={<SaleInvoiceTermsAndSubmit />} /> 
        <Route path="/EditSaleInvoice/:id" element={<EditSaleInvoice />} />
        <Route path="GetAllSaleInvoices" element={<GetAllSaleInvoices />} /> 
         <Route path="GetAllPurchaseInvoices" element={<GetAllPurchaseInvoices />} /> 
        <Route path="ExcelUploader" element={<ExcelUploader />} /> 
        <Route path="PurchaseInvoiceExcelUploader" element={<PurchaseInvoiceExcelUploader />} /> 
        <Route path="PurchaseExcelUploader" element={<PurchaseExcelUploader />} /> 
        <Route path="Discount" element={<Discount />} /> 
        <Route path="ForgetPassword" element={<ForgetPassword />} /> 
        <Route path="AdminReport" element={<AdminReport />} /> 
        <Route path="ChangePassword" element={<ChangePassword />} /> 
        <Route path="PaymentDetails" element={<PaymentDetails />} /> 
        <Route path="AddPayment" element={<AddPayment />} /> 
      </Routes>
    </Router>
  );
}

export default App;
